const VDB_ID = 'G-XNBC194N48';

export default function analytics(ga_id) {
  window.gtag('config', VDB_ID);
  if (ga_id && ga_id !== '') {
    window.gtag('config', 'G-68P7VQ1KR6');
  }
}
